import Sections from '../components/Sections';
import ApplicationView from './common/ApplicationView';
import Modal from './Modal';

/* global fbq */
export default class HomeView extends ApplicationView
{
  start()
  {
    super.start(Sections.sections.HOME, document.querySelector('.home'));

    // this.download_button = document.querySelector('.home__button');
    // this.download_button_text = 'Download ';

    this.mac_container = document.querySelector('.home__mac');
    this.windows_container = document.querySelector('.home__windows');
    this.linux_container = document.querySelector('.home__linux');

    switch (this.get_os())
    {
    case 'mac' :
      this.mac_container.classList.remove('hidden');
      break;
    case 'windows':
      this.windows_container.classList.remove('hidden');
      break;
    case 'linux':
      this.linux_container.classList.remove('hidden');
      break;
    default:
      this.mac_container.classList.remove('hidden');
    }

    this.video_container = document.querySelector('.home__video');
    this.video = document.querySelector('.home__video-video');

    this.video_volume_on_icon = document.querySelector('.home__video-volume-on');
    this.video_volume_off_icon = document.querySelector('.home__video-volume-off');

    this.video_muted = true;

    // this.download_button.textContent = this.download_button_text;
  }

  on_video_ended()
  {
    this.video.setAttribute('muted', 'true');
    this.video.muted = true;

    this.video_volume_off_icon.classList.remove('hidden');
    this.video_volume_on_icon.classList.add('hidden');

    this.video.play();
  }

  on_video_click()
  {
    if (this.video_muted)
    {
      this.video.removeAttribute('muted');
      this.video.muted = false;

      this.video_volume_off_icon.classList.add('hidden');
      this.video_volume_on_icon.classList.remove('hidden');

      this.video_muted = false;
    }
    else
    {
      this.video.setAttribute('muted', 'true');
      this.video.muted = true;

      this.video_volume_off_icon.classList.remove('hidden');
      this.video_volume_on_icon.classList.add('hidden');

      this.video_muted = true;
    }
  }

  on_container_click()
  {
    fbq('track', 'ViewContent');

    setTimeout(() =>
    {
      window.open('https://compress.mov/thank-you', '_self');
    }, 500);
  }

  show_differences(os)
  {
    const store = os === 'mac' ? 'Mac App Store' : 'Microsoft Store';
    let title = 'What\'s the difference?';
    // let path = `images/casestudies/${Configuration.is_mobile ? 'mobile' : 'originals'}/${case_image}`;
    let body = `<div class="home__differences">
                  Compress is completely free. The ${store} version is identical to the free version and there are no features left out of the free version. Purchasing the store version directly funds the development of Compress and shows your support
                  <span><svg class="home__heart-icon" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="heart" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-heart fa-w-16 fa-2x"><path fill="currentColor" d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z" class=""></path></svg></span>
                  <br><br>
                  <a class="button home__button" href="https://donate.stripe.com/4gM4gz51Rd8y9cW8iq5EY05" target="_blank">Donate</a>
                </div>
                `;

    Modal.show({ title, body });
  }

  show_mac_options()
  {
    let title = 'Select your version';
    // let path = `images/casestudies/${Configuration.is_mobile ? 'mobile' : 'originals'}/${case_image}`;
    let body = `<div class="home__mac-options">
                  Select the version of Compress that’s right for your Mac
                  <div class="home__mac-options-buttons">
                    <a class="button home__button" href="https://s3.us-east-1.amazonaws.com/compress.mov/releases/Compress_arm64.dmg">Mac with Apple Silicon chip</a>
                    <a class="button home__button home__button--secondary" href="https://s3.us-east-1.amazonaws.com/compress.mov/releases/Compress_x64.dmg">Mac with Intel chip</a>
                  </div>
                </div>
                `;

    Modal.show({ title, body });
  }

  show_beta_options()
  {
    let title = 'Download Compress 5 Beta';
    // let path = `images/casestudies/${Configuration.is_mobile ? 'mobile' : 'originals'}/${case_image}`;
    let body = `<div class="home__beta-options">
                  Compress 5 is a major update with a new design and new features. <span class="home__beta-options-link" onclick="app.home_view.show_v5_features()">Learn more</span>
                  <br>
                  <br>
                  <div class="home__beta-options-buttons">
                    <a class="button home__button ${this.get_os() !== 'windows' ? 'home__button--secondary' : ''}" href="https://s3.us-east-1.amazonaws.com/compress.mov/releases/beta/CompressBetaSetup.zip">Compress for Windows</a>
                    <a class="button home__button ${this.get_os() !== 'linux' ? 'home__button--secondary' : ''}" href="https://snapcraft.io/compress-video">Compress for Linux</a>
                    <a class="button home__button ${this.get_os() !== 'mac' ? 'home__button--secondary' : ''}" href="https://s3.us-east-1.amazonaws.com/compress.mov/releases/beta/CompressBeta_arm64.dmg">Compress for Mac with Apple Silicon chip</a>
                    <a class="button home__button ${this.get_os() !== 'mac' ? 'home__button--secondary' : ''}" href="https://s3.us-east-1.amazonaws.com/compress.mov/releases/beta/CompressBeta_x64.dmg">Compress for Mac with Intel chip</a>
                  </div>
                </div>
                `;

    Modal.show({ title, body });
  }

  show_v5_features()
  {
    let title = 'What\'s new in Compress 5?';
    // let path = `images/casestudies/${Configuration.is_mobile ? 'mobile' : 'originals'}/${case_image}`;
    let body = `<div class="home__v5-features">
                  <div class="home__beta-options-link" onclick="app.home_view.show_beta_options()">Download Compress 5 Beta</div>
                  <br>
                  Here are some of the highlights:
                  <ul>
                    <li>Ability to record secondary screen</li>
                    <li>Added GPU Encoding</li>
                    <li>Improve Screen Recording: Now it uses fewer resources to record the screen</li>
                    <br>
                    <li>Ability to create an account to save stats and unlock features</li>
                    <br>
                    <li>Ability to record the screen</li>
                    <li>Ability to record a portion of the screen</li>
                    <li>Ability to record the screen with system audio (only Windows)</li>
                    <li>Ability to record the screen at different resolutions</li>
                    <li>Ability to trim recorded screen</li>
                    <br>
                    <li>Ability to change video and audio speed</li>
                    <li>Ability to reverse video</li>
                    <li>Ability to rotate video</li>
                    <li>Ability to change video framerate</li>
                    <li>Added support to HDR videos</li>
                    <li>Added AV1 encoding</li>
                    <li>Improved video preview when resizing time on trim</li>
                    <br>
                    <li>Ability to select Audio Codec (MP3, AAC, OPUS or FLAC)</li>
                    <li>Ability to select Audio Quality</li>
                    <li>Ability to select specific audio channel</li>
                    <li>Ability to merge audio channels</li>
                    <br>
                    <li>Ability to drag a folder full of videos to compress</li>
                    <li>Ability to keep video metadata</li>
                    <li>Record amount of compressions</li>
                    <li>Record amount of MB reduced</li>
                    <li>Hide drop options container by pressing Escape</li>
                    <li>Hide settings by pressing Escape</li>
                    <li>Hide settings view when compression starts</li>
                    <li>Increase file size in discord mode (25mb)</li>
                    <li>Reorganize Settings in 4 tabs: General, Video, Audio, Recording</li>
                    <li>Ability to import and export settings</li>
                    <br>
                    <li>Added more Feedback Channels</li>
                    <li>Support custom shortcuts to record screen</li>
                    <li>Huge refactoring on the app that allowed us to add new features</li>
                    <li>Force pixel format to yuv420p for better compatibility</li>
                    <li>Improved app translation system</li>
                    <li>Improved compression error messages</li>
                    <li>Added report error button on compression error</li>
                    <li>Fixed start app from context menu on Windows</li>
                    <li>Fixed close app from task bar on Windows</li>
                  </ul>
                  <div class="home__beta-options-link" onclick="app.home_view.show_beta_options()">Download Compress 5 Beta</div>
                </div>
                `;

    Modal.show({ title, body });
  }

  get_os()
  {
    let userAgent = window.navigator.userAgent;
    let platform = window.navigator.platform;
    let macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
    let windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
    let iosPlatforms = ['iPhone', 'iPad', 'iPod'];
    let os = null;

    if (macosPlatforms.indexOf(platform) !== -1)
    {
      os = 'mac';
    }
    else if (iosPlatforms.indexOf(platform) !== -1)
    {
      os = 'ios';
    }
    else if (windowsPlatforms.indexOf(platform) !== -1)
    {
      os = 'windows';
    }
    else if (/Android/.test(userAgent))
    {
      os = 'android';
    }
    else if (!os && /Linux/.test(platform))
    {
      os = 'linux';
    }

    return os;
  }
}
